// ============================================================================
// SectionHeader — en-tete de section des ecrans Admin (AD-A, STOP-10)
// ============================================================================
// Porte du PoC components/admin/shared.tsx:112-132 avec les TOKENS DU PARC
// (jamais les classes shadcn text-muted-foreground/border du PoC). STOP-10
// TRANCHEE (David, 2026-07-18) : composant LOCAL gest — PAS un variant de
// PageHeader @gs/ui (1er usage, on ne gonfle pas @gs/ui prematurement ; meme
// principe que AdminSideNav). Promotion @gs/ui si un 2e ecran le reclame.

import type { ReactNode } from 'react';

export function SectionHeader({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children?: ReactNode;
}) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 border-b border-slate-200 pb-3 dark:border-slate-700">
      <div>
        <h3 className="text-body font-semibold text-slate-800 dark:text-slate-100">{title}</h3>
        {description ? (
          <p className="mt-0.5 text-meta text-slate-500 dark:text-slate-400">{description}</p>
        ) : null}
      </div>
      {children ? <div className="flex items-center gap-2">{children}</div> : null}
    </div>
  );
}
